module.exports = __webpack_public_path__ + "img/04_sub_no.1d720e3e.svg";